import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { usePagination } from '@web/app/shared';
import { type WorkspaceContext, createNavigator, extractRouteParams } from '@web/app/shared/utils/route-utils';

import { useAgents } from '@codes/agents';

export const useAgentCatalog = () => {
    const navigate = useNavigate();
    const routeParams = extractRouteParams<WorkspaceContext>(useParams());
    const { workspaceId, projectId } = routeParams;
    const [searchParams, setSearchParams] = useSearchParams();
    const navigator = createNavigator(navigate, { workspaceId, projectId });
    const [showCreateDialog, setShowCreateDialog] = useState(false);

    const searchQuery = searchParams.get('search') || '';
    const page = parseInt(searchParams.get('page') || '0', 10);
    const limit = 9;

    const {
        data: agentsData,
        isLoading: isAgentsLoading,
        refetch,
    } = useAgents({
        name: searchQuery,
        view: 'admin',
        page,
        limit,
    });

    const totalCount = agentsData?.total || 0;
    const totalPages = Math.ceil(totalCount / limit);
    const { paginationRange } = usePagination({
        totalCount,
        pageSize: limit,
        currentPage: page,
        siblingCount: 1,
    });

    const handleSearchChange = (query: string) => {
        setSearchParams(prev => {
            if (query) {
                prev.set('search', query);
            } else {
                prev.delete('search');
            }
            prev.set('page', '0');
            return prev;
        });
    };

    const handleAddAgent = () => {
        setShowCreateDialog(true);
    };

    const handleChat = (id: string) => {
        navigator.navigateTo(`/agent-catalogs/${id}/chat`);
    };

    const handleSettings = (id: string) => {
        navigator.navigateTo(`/agent-catalogs/${id}/settings`);
    };

    const handleShare = (id: string) => {
        // TODO: 공유 기능 구현
        console.log('Share agent:', id);
    };

    const handleDelete = (id: string) => {
        // TODO: 삭제 기능 구현
        console.log('Delete agent:', id);
    };

    const handlePageChange = (newPage: number) => {
        setSearchParams(prev => {
            prev.set('page', newPage.toString());
            return prev;
        });
    };

    const handleCreateSuccess = () => {
        setShowCreateDialog(false);
        setTimeout(() => {
            refetch();
        }, 2000);
    };

    const handleCloseCreateDialog = () => {
        setShowCreateDialog(false);
    };

    return {
        searchQuery,
        page,
        totalPages,
        showCreateDialog,
        agentsData,
        isAgentsLoading,
        paginationRange,

        handleSearchChange,
        handleAddAgent,
        handleChat,
        handleSettings,
        handleShare,
        handleDelete,
        handlePageChange,
        handleCreateSuccess,
        handleCloseCreateDialog,
    };
};
